import { combineReducers } from 'redux'
import merchantReducer from './merchantReducer'
import settingsReducer from './settingsReducer'

const rootReducer = combineReducers({
    settings: settingsReducer,
    merchant: merchantReducer
});

export default rootReducer